import { render, staticRenderFns } from "./FinmediaInvoiceContent.vue?vue&type=template&id=208ca952&scoped=true&"
import script from "./FinmediaInvoiceContent.vue?vue&type=script&lang=ts&"
export * from "./FinmediaInvoiceContent.vue?vue&type=script&lang=ts&"
import style0 from "./FinmediaInvoiceContent.vue?vue&type=style&index=0&id=208ca952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ca952",
  null
  
)

export default component.exports